export const companyAdminKeys = {
  getConfigsByType: (companyId: string, configType: string) => [
    'company-configs',
    companyId,
    configType,
  ],
  getAccessRequests: ({ ENTRY_TYPE }: { ENTRY_TYPE: 'WORKSPACE' }) => [
    'access-requests',
    ENTRY_TYPE,
  ],
  getMongoAuthToken: () => ['mongo-auth-token'],
};

export const suggestionContactsKeys = {
  getSuggestionContacts: ({ companyId }: { companyId: string }) => [
    'suggestion-contacts',
    companyId,
  ],
};
